export class QueueCharacteristics {
  public id: number;
  public siterecordCharacteristicsExtendedId: number;
  public queueCharacteristicsOrder: number;
  public queueType: string; // QueueType;
  public queueDetectionMethod: string; // QueueDetectionMethodType;
}



// WEBPACK FOOTER //
// ./src/app/models/queueCharacteristics.model.ts